import builder from '../builder';
import TimeClockFileCash from '../../streamline-icons/light/time-clock-file-cash.svg';

export default builder('IconTimeClockFileCashLight', TimeClockFileCash);
